/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SearchCustomerRequest { 
    creationDateFrom?: Date;
    /**
     * The page number within the search you want to request, from 1 to n. Default value=0
     */
    page?: number;
    /**
     * The page size. Default value=50
     */
    pageSize?: number;
    creationDateTo?: Date;
    code?: string;
    documentNumber?: string;
    partOfName?: string;
    email?: string;
    periodicityType?: SearchCustomerRequest.PeriodicityTypeEnum;
    pep?: boolean;
    watched?: boolean;
}
export namespace SearchCustomerRequest {
    export type PeriodicityTypeEnum = 'Occasional' | 'Habitual';
    export const PeriodicityTypeEnum = {
        Occasional: 'Occasional' as PeriodicityTypeEnum,
        Habitual: 'Habitual' as PeriodicityTypeEnum
    };
}
